<template>
  <div>
    <vx-tooltip delay="1" :text="tooltipText" tooltipPosition="top">
    <div v-if="!edit" @dblclick="openEdit">
      <div v-if="this.value !== null" >
        <feather-icon
          style="float: right"
          icon="Edit2Icon"
          svgClasses="h-5 w-5 mr-1 hover:text-primary cursor-pointer z-100"
          @click="openEdit"
          
        />
        <div v-for="(item,i) of value.split(',')" :key="i">
          {{ item }}
          <br>
        </div>

      </div>
      <div v-else>
        <action-icon
          icon="PlusCircleIcon"
          :tooltip="$t('add') | capitalize"
          @click="openEdit"
        />
      </div>
    </div>
    <div v-else>
      <vs-input
        v-model="text"
        class="w-full"
        :placeholder="inputPlaceholder"
        @keyup.enter="submit"
        @keyup.esc="closeEdit"
      />
    </div>
    </vx-tooltip>
  </div>
</template>

<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  components: {
    ActionIcon,
  },
  props:{
    value:{
      type:[String,Number]
    },
    tooltipText:{
      default:'Doble Click to Edit'
    },
    inputPlaceholder:{
      default:''
    }
  },
  data() {
    return {
      edit: false,
      text: '',
    }
  },
  methods: {
    openEdit() {
      this.text = this.value === null ? '' : this.value
      this.edit = true
    },
    closeEdit() {
      this.edit = false
    },
    submit() {
      if (this.text === '') {
        return
      }
      this.closeEdit()
      this.$emit('update', this.text)
    }
  },
}
</script>

<style>
</style>